import type { AddonApp } from '../types';

interface AddonAppFrameProps {
  addonApp: AddonApp;
}

/**
 * Embeds an addon app that runs on the same origin. Auth works through the shared
 * auth_token cookie, so no token is passed to the frame.
 */
export function AddonAppFrame({ addonApp }: AddonAppFrameProps) {
  return (
    // Fills the remaining height of the layout main area
    <div className="flex min-h-0 flex-1 flex-col">
      <iframe
        src={addonApp.url}
        title={addonApp.name}
        className="bg-surface w-full flex-1 border-0"
      />
    </div>
  );
}
